module.exports = __webpack_public_path__ + "img/INSTALL_DT.8324a981.png";